import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Container } from "@mui/material";
import Header from "./components/Header";
import Home from "./pages/Home";
import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import ProductList from "./pages/Product/List";
import ProductView from "./pages/Product/View";
import Settings from "./pages/Settings";
import Cart from "./pages/Cart";

import ProjectsView from "./pages/Projects/View";
import ProjectsList from "./pages/Projects/List";

import QuoteList from "./pages/Quote/List";
import QuoteDetails from "./pages/Quote/View";
import AdminProductList from "./pages/Admin/products/List";
import AdminProductEdit from "./pages/Admin/products/Edit";
import AdminProductAdd from "./pages/Admin/products/Add";
import AdminOverview from "./pages/Admin/Overview";
import AdminQuoteDetails from "./pages/Admin/Quote/Details";

import AdminProjectsDetails from "./pages/Admin/Projects/Details";
import AdminProjectsList from "./pages/Admin/Projects/List";

import AdminProductView from "./pages/Admin/products/Details";
import AdminUsers from "./pages/Admin/Users";
import AdminCompaniesList from "./pages/Admin/companies/List";
import AdminCompaniesDetails from "./pages/Admin/companies/Details";

import AdminQuoteList from "./pages/Admin/Quote/List";
import { auth, db } from "./firebase-config";
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import "./index.css";
import Page404 from "./pages/Page404";

function App() {
  const [userLoading, setUserLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {
    setUserLoading(true);
  
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          setCurrentUser(user);
          console.log(`setCurrentUser(${user.uid})`);
  
          const userRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userRef);
  
          if (userSnap.exists()) {
            // Update lastOnline timestamp if user exists
            await updateDoc(userRef, { lastOnline: serverTimestamp() });
          } else {
            // Add new user to Firestore
            await setDoc(userRef, {
              email: user.email,
              name: user.displayName || "Unknown",
              companyId: null, // Default null, can be updated later
              createdAt: serverTimestamp(),
              lastOnline: serverTimestamp(),
            });
          }
  
          // Check if user is an admin
          const adminRef = doc(db, "admins", user.uid);
          const adminSnap = await getDoc(adminRef);
          console.log(`setIsAdmin(${adminSnap.exists()})`);
          setIsAdmin(adminSnap.exists());
  
        } catch (error) {
          console.error("Error managing user data:", error);
          setIsAdmin(false);
        }
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setUserLoading(false);
    });
  }, []);

  if (userLoading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Login />;
  }

  return (
    <Router>
      <Header>
        <Container>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/settings" element={<Settings />} />
            
            <Route path="/Projects" element={<ProjectsList />} />
            <Route path="/Projects/:projectId" element={<ProjectsView />} />


            <Route path="/products" element={<ProductList />} />
            <Route path="/products/:productId" element={<ProductView />} />
           
            <Route path="/cart" element={<Cart />} />
           
            <Route path="/quotes" element={<QuoteList />} />
            <Route path="/quote/:id" element={<QuoteDetails />} />

            {/* Admin Routes (Protected) */}
            <Route path="/admin" element={isAdmin ? <AdminOverview /> : <Page404 />} />
            <Route path="/admin/products" element={isAdmin ? <AdminProductList /> : <Page404 />} />
            <Route path="/admin/products/add" element={isAdmin ? <AdminProductAdd /> : <Page404 />} />
            <Route path="/admin/products/edit/:productId" element={isAdmin ? <AdminProductEdit /> : <Page404 />} />
            <Route path="/admin/products/:id" element={isAdmin ? <AdminProductView /> : <Page404 />} />
            
            <Route path="/admin/quotes" element={isAdmin ? <AdminQuoteList /> : <Page404  />} />
            <Route path="/admin/quotes/:id" element={isAdmin ? <AdminQuoteDetails /> : <Page404  />} />
           
           
            <Route path="/admin/projects" element={isAdmin ? <AdminProjectsList /> : <Page404  />} />
            <Route path="/admin/projects/:projectid" element={isAdmin ? <AdminProjectsDetails /> : <Page404  />} />
           

            <Route path="/admin/Users" element={isAdmin ? <AdminUsers /> : <Page404  />} />
           
            <Route path="/admin/companies" element={isAdmin ? <AdminCompaniesList /> : <Page404  />} />
            <Route path="/admin/companies/:id" element={isAdmin ? <AdminCompaniesDetails /> : <Page404  />} />
           

            
            {/* 404 Page */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Container>
      </Header>
    </Router>
  );
}

export default App;
